@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div
    class="option-group-container spread-container"
    [style.--option-group-rows]="rows"
    [ngClass]="[!showMoreLessButtonVisible && isSingleRowOfOptions() ? 'ht-of-single-row-options' : '', tupleClass]">
    <div class="option-group-header">
        <span>{{ firstParticipant }}</span>
        @if (numberOfOptions > 2) {
            <span>{{ sitecore.event.Tie }}</span>
        }
        <span>{{ secondParticipant }}</span>
    </div>
    <ng-container *rxFor="let group of optionGroups | slice: 0 : visibleOptionsLimit; trackBy: trackGroup">
        @for (option of group.options; track trackOption($index, option)) {
            @if (option) {
                <ms-bet-builder-option
                    [tracking]="{ source: tracking }"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                    [sourceOfPick]="sourceOfPick" />
            } @else {
                <div class="option option-pick">
                    <div class="offline">
                        <div class="value">-</div>
                    </div>
                </div>
            }
        }
    </ng-container>
</div>
@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button" [ngClass]="{ expanded: expanded }" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }}
        <span class="right-icon"><vn-icon name="theme-right" size="12" /></span>
    </div>
}
